import React from 'react';
import PropTypes from 'prop-types';
import { Button, Radio } from 'adp-react-components';

//const deliveryoptions=["maheshkadhur@gmail.com",'998877'];
export default class DeliveryMethod extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveryType: {},
      selectedValue: '',
      radioValue: ''
    };
    this.onChangeHandle = this.onChangeHandle.bind(this);
  }
  componentWillMount() {
    fetch(context+'/enroll/adpPassword.faces?fypAjaxForm', {
      method: 'POST',
      //same-origin is needed to keep the cookies
      credentials: 'same-origin',

      headers: {
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',

        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body:
        'ftpAjaxForm=fypAjaxForm&fypAjaxForm:submitButton=&javax.faces.ViewState=' +
        Tier0.get('javax.faces.ViewState').value
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage(data.wizard.message);
          return;
        }
        if (data.success == 'true' || data.success == true) {
          this.setState({
            deliveryType: data.deliveryType
          });
        }
      });
  }

  onChangeHandle(value1) {
    var deliveryvalue = undefined;
    if (value1 == 'mailid') {
      deliveryvalue = 0;
    } else {
      var len = value1.length;
      deliveryvalue = value1.charAt(len - 1);
    }
    this.setState({
      selectedValue: deliveryvalue,
      radioValue: value1
    });
    this.props.fetchDeliveryMethod(this.state.deliveryType[value1]);
  }
  onSubmit(event) {
    this.props.showAnswerYourQns(this.state.selectedValue);
  }
  isSeletedRadio(value) {
    return value != '';
  }
  handleEnterKeyPress(e) {

    if (this.isSeletedRadio(this.state.radioValue) && e.charCode == 13) {
      e.preventDefault(); //preventing html5 default form submit
      this.onSubmit();
    }
  }

  render() {
    let isValid = this.isSeletedRadio(this.state.radioValue);
    let deliveryMethods = this.state.deliveryType;
    return (
      <div className="vdl-row login-form">
        <div className="vdl-col-md-12">
          <form className="adp-form">
            <div className="form-group">
              <div className="showcase">
                {Object.keys(deliveryMethods).map((keyItem, valueItem) => {
                  if (deliveryMethods[keyItem] != '') {
                    return (
                      <div className="vdl-radio0" key={keyItem}>
                        <Radio
                          className="vdl-radio-custom-text"
                          value={keyItem}
                          onKeyPress={this.handleEnterKeyPress.bind(this)}
                          radioGroupValue={this.state.radioValue}
                          onChange={this.onChangeHandle}>
                          {deliveryMethods[keyItem]}
                        </Radio>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
            <div className="form-group submit vdl-text-xs-center">
              <Button
                className="primary"
                disabled={!isValid}
                onClick={this.onSubmit.bind(this)}>
                {this.props.sendcode}
              </Button>
            </div>
            {/* form-group submit vdl-text-xs-center */}
          </form>
          {/* adp-form */}
        </div>
        {/* vdl-col-md-12 */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/admin-login/forgotflow/delivery-method.js